import type { FC } from 'react';
import type { CreationItem } from '../types';
import { CreatorAvatar } from './CreatorAvatar';
import { VideoCard } from './VideoCard';

interface VideoCardWrapper {
  creation: CreationItem;
  onSelected: (id: string) => void;
}
export const VideoCardWrapper: FC<VideoCardWrapper> = ({ creation, onSelected }) => {
  return (
    <div className="w-full shrink-0 overflow-hidden rounded-[20px] border-2 border-white/10 md:rounded-10">
      <VideoCard
        creationId={creation.id ?? ''}
        videoUrl={creation.creation?.uri ?? ''}
        posterUrl={creation.creation?.cover_uri ?? ''}
        onSelected={onSelected}
      />
      <div className="p-6 md:p-3">
        <h2 className="mb-4 truncate text-lg text-white md:mb-2 md:text-xs">{creation.title}</h2>
        <div className="flex items-center gap-2 md:gap-1">
          <CreatorAvatar
            nickname={creation.creator?.nick_name ?? ''}
            avatar={creation.creator?.avatar ?? ''}
            className="size-6 md:size-5"
          />
          <span className="text-base text-white/70 md:text-xs">{creation.creator?.nick_name}</span>
        </div>
      </div>
    </div>
  );
};
